
import CryptoJS from 'crypto-js';

const SECRET_KEY_HEX = import.meta.env.VITE_APPROVAL_PARAMS_DECRYPTION_KEY;

// convert hex to WordArray
const key = CryptoJS.enc.Hex.parse(SECRET_KEY_HEX);

export function encryptPassword(password: string): string {
  const iv = CryptoJS.lib.WordArray.random(16);

  const encrypted = CryptoJS.AES.encrypt(password, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return `${CryptoJS.enc.Base64.stringify(iv)}:${encrypted.ciphertext.toString(CryptoJS.enc.Base64)}`;
}

/**
 * Decrypt a value encrypted by the backend's encryptSapPassword
 * (AES-256-CBC, iv:ciphertext both in Base64).
 * Returns the original plain text, or the input unchanged if it doesn't look
 * like an encrypted value — so plain-text fallbacks still render correctly.
 */
export function decryptValue(encryptedData: string): string {
  if (!encryptedData || !encryptedData.includes(':')) return encryptedData;
  try {
    const [ivBase64, cipherBase64] = encryptedData.split(':');
    if (!ivBase64 || !cipherBase64) return encryptedData;

    const iv = CryptoJS.enc.Base64.parse(ivBase64);
    const decrypted = CryptoJS.AES.decrypt(cipherBase64, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    const plain = decrypted.toString(CryptoJS.enc.Utf8);
    // If decryption produced an empty string the data wasn't actually encrypted
    return plain || encryptedData;
  } catch {
    return encryptedData;
  }
}
